// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/lg.ttf?22t19m", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/lg.woff?22t19m", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/lg.svg?22t19m", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/vimeo-play.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/video-play.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/youtube-play.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/loading.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___, { hash: "#lg" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'lg';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

.lg-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'lg' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.lg-actions .lg-next, .lg-actions .lg-prev {
  background-color: rgba(0, 0, 0, 0.45);
  border-radius: 2px;
  color: #999;
  cursor: pointer;
  display: block;
  font-size: 22px;
  margin-top: -10px;
  padding: 8px 10px 9px;
  position: absolute;
  top: 50%;
  z-index: 1080;
  outline: none;
  border: none;
  background-color: transparent;
}

.lg-actions .lg-next.disabled, .lg-actions .lg-prev.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.lg-actions .lg-next:hover, .lg-actions .lg-prev:hover {
  color: #FFF;
}

.lg-actions .lg-next {
  right: 20px;
}

.lg-actions .lg-next:before {
  content: "\\e095";
}

.lg-actions .lg-prev {
  left: 20px;
}

.lg-actions .lg-prev:after {
  content: "\\e094";
}

@keyframes lg-right-end {
  0% {
    left: 0;
  }
  50% {
    left: -30px;
  }
  100% {
    left: 0;
  }
}

@keyframes lg-left-end {
  0% {
    left: 0;
  }
  50% {
    left: 30px;
  }
  100% {
    left: 0;
  }
}

.lg-outer.lg-right-end .lg-object {
  animation: lg-right-end 0.3s;
  position: relative;
}

.lg-outer.lg-left-end .lg-object {
  animation: lg-left-end 0.3s;
  position: relative;
}

.lg-toolbar {
  z-index: 1082;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.45);
}

.lg-toolbar .lg-icon {
  color: #999;
  cursor: pointer;
  float: right;
  font-size: 24px;
  height: 47px;
  line-height: 27px;
  padding: 10px 0;
  text-align: center;
  width: 50px;
  text-decoration: none !important;
  outline: medium none;
  background: none;
  border: none;
  box-shadow: none;
  transition: color 0.2s linear;
}

.lg-toolbar .lg-icon:hover {
  color: #FFF;
}

.lg-toolbar .lg-close:after {
  content: "\\e070";
}

.lg-toolbar .lg-download:after {
  content: "\\e0f2";
}

.lg-sub-html {
  background-color: rgba(0, 0, 0, 0.45);
  bottom: 0;
  color: #EEE;
  font-size: 16px;
  left: 0;
  padding: 10px 40px;
  position: fixed;
  right: 0;
  text-align: center;
  z-index: 1080;
}

.lg-sub-html h4 {
  margin: 0;
  font-size: 13px;
  font-weight: bold;
}

.lg-sub-html p {
  font-size: 12px;
  margin: 5px 0 0;
}

#lg-counter {
  color: #999;
  display: inline-block;
  font-size: 16px;
  padding-left: 20px;
  padding-top: 12px;
  vertical-align: middle;
}

.lg-toolbar, .lg-prev, .lg-next {
  opacity: 1;
  transition: transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, color 0.2s linear;
}

.lg-hide-items .lg-prev {
  opacity: 0;
  transform: translate3d(-10px, 0, 0);
}

.lg-hide-items .lg-next {
  opacity: 0;
  transform: translate3d(10px, 0, 0);
}

.lg-hide-items .lg-toolbar {
  opacity: 0;
  transform: translate3d(0, -10px, 0);
}

body:not(.lg-from-hash) .lg-outer.lg-start-zoom .lg-object {
  transform: scale3d(0.5, 0.5, 0.5);
  opacity: 0;
  transition: transform 250ms cubic-bezier(0, 0, 0.25, 1) 0s, opacity 250ms cubic-bezier(0, 0, 0.25, 1) !important;
  transform-origin: 50% 50%;
}

body:not(.lg-from-hash) .lg-outer.lg-start-zoom .lg-item.lg-complete .lg-object {
  transform: scale3d(1, 1, 1);
  opacity: 1;
}

.lg-outer .lg-thumb-outer {
  background-color: #0D0A0A;
  bottom: 0;
  position: absolute;
  width: 100%;
  z-index: 1080;
  max-height: 350px;
  transform: translate3d(0, 100%, 0);
  transition: transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;
}

.lg-outer .lg-thumb-outer.lg-grab .lg-thumb-item {
  cursor: -o-grab;
  cursor: -ms-grab;
  cursor: grab;
}

.lg-outer .lg-thumb-outer.lg-grabbing .lg-thumb-item {
  cursor: move;
  cursor: -o-grabbing;
  cursor: -ms-grabbing;
  cursor: grabbing;
}

.lg-outer .lg-thumb-outer.lg-dragging .lg-thumb {
  transition-duration: 0s !important;
}

.lg-outer.lg-thumb-open .lg-thumb-outer {
  transform: translate3d(0, 0%, 0);
}

.lg-outer .lg-thumb {
  padding: 10px 0;
  height: 100%;
  margin-bottom: -5px;
}

.lg-outer .lg-thumb-item {
  cursor: pointer;
  float: left;
  overflow: hidden;
  height: 100%;
  border: 2px solid #FFF;
  border-radius: 4px;
  margin-bottom: 5px;
}

@media (min-width: 1025px) {
  .lg-outer .lg-thumb-item {
    transition: border-color 0.25s ease;
  }
}

.lg-outer .lg-thumb-item.active, .lg-outer .lg-thumb-item:hover {
  border-color: #a90707;
}

.lg-outer .lg-thumb-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lg-outer.lg-has-thumb .lg-item {
  padding-bottom: 120px;
}

.lg-outer.lg-can-toggle .lg-item {
  padding-bottom: 0;
}

.lg-outer.lg-pull-caption-up .lg-sub-html {
  transition: bottom 0.25s ease;
}

.lg-outer.lg-pull-caption-up.lg-thumb-open .lg-sub-html {
  bottom: 100px;
}

.lg-outer .lg-toggle-thumb {
  background-color: #0D0A0A;
  border-radius: 2px 2px 0 0;
  color: #999;
  cursor: pointer;
  font-size: 24px;
  height: 39px;
  line-height: 27px;
  padding: 5px 0;
  position: absolute;
  right: 20px;
  text-align: center;
  top: -39px;
  width: 50px;
  outline: medium none;
  border: none;
}

.lg-outer .lg-toggle-thumb:after {
  content: "\\e1ff";
}

.lg-outer .lg-toggle-thumb:hover {
  color: #FFF;
}

.lg-outer .lg-video-cont {
  display: inline-block;
  vertical-align: middle;
  max-width: 1140px;
  max-height: 100%;
  width: 100%;
  padding: 0 5px;
}

.lg-outer .lg-video {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
  position: relative;
}

.lg-outer .lg-video .lg-object {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}

.lg-outer .lg-video .lg-video-play {
  width: 84px;
  height: 59px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -42px;
  margin-top: -30px;
  z-index: 1080;
  cursor: pointer;
}

.lg-outer .lg-has-vimeo .lg-video-play {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat scroll 0 0 transparent;
}

.lg-outer .lg-has-vimeo:hover .lg-video-play {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat scroll 0 -58px transparent;
}

.lg-outer .lg-has-html5 .lg-video-play {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat scroll 0 0;
  height: 64px;
  margin-left: -32px;
  margin-top: -32px;
  width: 64px;
  opacity: 0.8;
}

.lg-outer .lg-has-html5:hover .lg-video-play {
  opacity: 1;
}

.lg-outer .lg-has-youtube .lg-video-play {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat scroll 0 0 transparent;
}

.lg-outer .lg-has-youtube:hover .lg-video-play {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat scroll 0 -60px transparent;
}

.lg-outer .lg-video-object {
  width: 100% !important;
  height: 100% !important;
  position: absolute;
  top: 0;
  left: 0;
}

.lg-outer .lg-has-video .lg-video-object {
  visibility: hidden;
}

.lg-outer .lg-has-video.lg-video-playing .lg-object, .lg-outer .lg-has-video.lg-video-playing .lg-video-play {
  display: none;
}

.lg-outer .lg-has-video.lg-video-playing .lg-video-object {
  visibility: visible;
}

.lg-progress-bar {
  background-color: #333;
  height: 5px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1083;
  opacity: 0;
  transition: opacity 0.08s ease 0s;
}

.lg-progress-bar .lg-progress {
  background-color: #a90707;
  height: 5px;
  width: 0;
}

.lg-progress-bar.lg-start .lg-progress {
  width: 100%;
}

.lg-show-autoplay .lg-progress-bar {
  opacity: 1;
}

.lg-autoplay-button:after {
  content: "\\e01d";
}

.lg-show-autoplay .lg-autoplay-button:after {
  content: "\\e01a";
}

.lg-outer.lg-css3.lg-zoom-dragging .lg-item.lg-complete.lg-zoomable .lg-img-wrap, .lg-outer.lg-css3.lg-zoom-dragging .lg-item.lg-complete.lg-zoomable .lg-image {
  transition-duration: 0s;
}

.lg-outer.lg-use-transition-for-zoom .lg-item.lg-complete.lg-zoomable .lg-img-wrap {
  transition: transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;
}

.lg-outer.lg-use-left-for-zoom .lg-item.lg-complete.lg-zoomable .lg-img-wrap {
  transition: left 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, top 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;
}

.lg-outer .lg-item.lg-complete.lg-zoomable .lg-img-wrap {
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}

.lg-outer .lg-item.lg-complete.lg-zoomable .lg-image {
  transform: scale3d(1, 1, 1);
  transition: transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.15s !important;
  transform-origin: 0 0;
  backface-visibility: hidden;
}

#lg-zoom-in:after {
  content: "\\e311";
}

#lg-actual-size {
  font-size: 20px;
}

#lg-actual-size:after {
  content: "\\e033";
}

#lg-zoom-out {
  opacity: 0.5;
  pointer-events: none;
}

#lg-zoom-out:after {
  content: "\\e312";
}

.lg-zoomed #lg-zoom-out {
  opacity: 1;
  pointer-events: auto;
}

.lg-outer .lg-pager-outer {
  bottom: 60px;
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
  z-index: 1080;
  height: 10px;
}

.lg-outer .lg-pager-outer.lg-pager-hover .lg-pager-cont {
  overflow: visible;
}

.lg-outer .lg-pager-cont {
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: top;
  margin: 0 5px;
}

.lg-outer .lg-pager-cont:hover .lg-pager-thumb-cont {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

.lg-outer .lg-pager-cont.lg-pager-active .lg-pager {
  box-shadow: 0 0 0 2px white inset;
}

.lg-outer .lg-pager-thumb-cont {
  background-color: #fff;
  color: #FFF;
  bottom: 100%;
  height: 83px;
  left: 0;
  margin-bottom: 20px;
  margin-left: -60px;
  opacity: 0;
  padding: 5px;
  position: absolute;
  width: 120px;
  border-radius: 3px;
  transition: opacity 0.15s ease 0s, transform 0.15s ease 0s;
  transform: translate3d(0, 5px, 0);
}

.lg-outer .lg-pager-thumb-cont img {
  width: 100%;
  height: 100%;
}

.lg-outer .lg-pager {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.7) inset;
  display: block;
  height: 12px;
  transition: box-shadow 0.3s ease 0s;
  width: 12px;
}

.lg-outer .lg-pager:hover, .lg-outer .lg-pager:focus {
  box-shadow: 0 0 0 8px white inset;
}

.lg-outer .lg-caret {
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px dashed;
  bottom: -10px;
  display: inline-block;
  height: 0;
  left: 50%;
  margin-left: -5px;
  position: absolute;
  vertical-align: middle;
  width: 0;
}

.lg-fullscreen:after {
  content: "\\e20c";
}

.lg-fullscreen-on .lg-fullscreen:after {
  content: "\\e20d";
}

.lg-outer #lg-dropdown-overlay {
  background-color: rgba(0, 0, 0, 0.25);
  bottom: 0;
  cursor: default;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1081;
  opacity: 0;
  visibility: hidden;
  transition: visibility 0s linear 0.18s, opacity 0.18s linear 0s;
}

.lg-outer.lg-dropdown-active .lg-dropdown, .lg-outer.lg-dropdown-active #lg-dropdown-overlay {
  transition-delay: 0s;
  transform: translate3d(0, 0px, 0);
  opacity: 1;
  visibility: visible;
}

.lg-outer.lg-dropdown-active #lg-share {
  color: #FFF;
}

.lg-outer .lg-dropdown {
  background-color: #fff;
  border-radius: 2px;
  font-size: 14px;
  list-style-type: none;
  margin: 0;
  padding: 10px 0;
  position: absolute;
  right: 0;
  text-align: left;
  top: 50px;
  opacity: 0;
  visibility: hidden;
  transform: translate3d(0, 5px, 0);
  transition: transform 0.18s linear 0s, visibility 0s linear 0.5s, opacity 0.18s linear 0s;
}

.lg-outer .lg-dropdown:after {
  content: "";
  display: block;
  height: 0;
  width: 0;
  position: absolute;
  border: 8px solid transparent;
  border-bottom-color: #FFF;
  right: 16px;
  top: -16px;
}

.lg-outer .lg-dropdown > li:last-child {
  margin-bottom: 0px;
}

.lg-outer .lg-dropdown > li:hover a, .lg-outer .lg-dropdown > li:hover .lg-icon {
  color: #333;
}

.lg-outer .lg-dropdown a {
  color: #333;
  display: block;
  white-space: pre;
  padding: 4px 12px;
  font-family: "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 12px;
}

.lg-outer .lg-dropdown a:hover {
  background-color: rgba(0, 0, 0, 0.07);
}

.lg-outer .lg-dropdown .lg-dropdown-text {
  display: inline-block;
  line-height: 1;
  margin-top: -3px;
  vertical-align: middle;
}

.lg-outer .lg-dropdown .lg-icon {
  color: #333;
  display: inline-block;
  float: none;
  font-size: 20px;
  height: auto;
  line-height: 1;
  margin-right: 8px;
  padding: 0;
  vertical-align: middle;
  width: auto;
}

.lg-outer #lg-share {
  position: relative;
}

.lg-outer #lg-share:after {
  content: "\\e80d";
}

.lg-outer #lg-share-facebook .lg-icon {
  color: #3b5998;
}

.lg-outer #lg-share-facebook .lg-icon:after {
  content: "\\e904";
}

.lg-outer #lg-share-twitter .lg-icon {
  color: #00aced;
}

.lg-outer #lg-share-twitter .lg-icon:after {
  content: "\\e907";
}

.lg-outer #lg-share-googleplus .lg-icon {
  color: #dd4b39;
}

.lg-outer #lg-share-googleplus .lg-icon:after {
  content: "\\e905";
}

.lg-outer #lg-share-pinterest .lg-icon {
  color: #cb2027;
}

.lg-outer #lg-share-pinterest .lg-icon:after {
  content: "\\e906";
}

.lg-outer .lg-img-rotate {
  position: absolute;
  padding: 0 5px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: transform 0.3s cubic-bezier(0.32, 0, 0.67, 0) 0s;
}

.lg-rotate-left:after {
  content: "\\e900";
}

.lg-rotate-right:after {
  content: "\\e901";
}

.lg-icon.lg-flip-hor, .lg-icon.lg-flip-ver {
  font-size: 26px;
}

.lg-flip-hor:after {
  content: "\\e902";
}

.lg-flip-ver:after {
  content: "\\e903";
}

.lg-group {
  *zoom: 1;
}

.lg-group:before, .lg-group:after {
  display: table;
  content: "";
  line-height: 0;
}

.lg-group:after {
  clear: both;
}

.lg-outer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  opacity: 0;
  outline: none;
  transition: opacity 0.15s ease 0s;
}

.lg-outer * {
  box-sizing: border-box;
}

.lg-outer.lg-visible {
  opacity: 1;
}

.lg-outer.lg-css3 .lg-item.lg-prev-slide, .lg-outer.lg-css3 .lg-item.lg-next-slide, .lg-outer.lg-css3 .lg-item.lg-current {
  transition-duration: inherit !important;
  transition-timing-function: inherit !important;
}

.lg-outer.lg-css3.lg-dragging .lg-item.lg-prev-slide, .lg-outer.lg-css3.lg-dragging .lg-item.lg-next-slide, .lg-outer.lg-css3.lg-dragging .lg-item.lg-current {
  transition-duration: 0s !important;
  opacity: 1;
}

.lg-outer.lg-grab img.lg-object {
  cursor: -o-grab;
  cursor: -ms-grab;
  cursor: grab;
}

.lg-outer.lg-grabbing img.lg-object {
  cursor: move;
  cursor: -o-grabbing;
  cursor: -ms-grabbing;
  cursor: grabbing;
}

.lg-outer .lg {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  max-height: 100%;
}

.lg-outer .lg-inner {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
}

.lg-outer .lg-item {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat scroll center center transparent;
  display: none !important;
}

.lg-outer.lg-css3 .lg-prev-slide, .lg-outer.lg-css3 .lg-current, .lg-outer.lg-css3 .lg-next-slide {
  display: inline-block !important;
}

.lg-outer.lg-css .lg-current {
  display: inline-block !important;
}

.lg-outer .lg-item, .lg-outer .lg-img-wrap {
  display: inline-block;
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
}

.lg-outer .lg-item:before, .lg-outer .lg-img-wrap:before {
  content: "";
  display: inline-block;
  height: 50%;
  width: 1px;
  margin-right: -1px;
}

.lg-outer .lg-img-wrap {
  position: absolute;
  padding: 0 5px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.lg-outer .lg-item.lg-complete {
  background-image: none;
}

.lg-outer .lg-item.lg-current {
  z-index: 1060;
}

.lg-outer .lg-image {
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  max-height: 100%;
  width: auto !important;
  height: auto !important;
}

.lg-outer.lg-show-after-load .lg-item .lg-object, .lg-outer.lg-show-after-load .lg-item .lg-video-play {
  opacity: 0;
  transition: opacity 0.15s ease 0s;
}

.lg-outer.lg-show-after-load .lg-item.lg-complete .lg-object, .lg-outer.lg-show-after-load .lg-item.lg-complete .lg-video-play {
  opacity: 1;
}

.lg-outer .lg-empty-html {
  display: none;
}

.lg-outer.lg-hide-download #lg-download {
  display: none;
}

.lg-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1040;
  background-color: #000;
  opacity: 0;
  transition: opacity 0.15s ease 0s;
}

.lg-backdrop.in {
  opacity: 1;
}

.lg-css3.lg-no-trans .lg-prev-slide, .lg-css3.lg-no-trans .lg-next-slide, .lg-css3.lg-no-trans .lg-current {
  transition: none 0s ease 0s !important;
}

.lg-css3.lg-use-css3 .lg-item {
  backface-visibility: hidden;
}

.lg-css3.lg-use-left .lg-item {
  backface-visibility: hidden;
}

.lg-css3.lg-fade .lg-item {
  opacity: 0;
}

.lg-css3.lg-fade .lg-item.lg-current {
  opacity: 1;
}

.lg-css3.lg-fade .lg-item.lg-prev-slide, .lg-css3.lg-fade .lg-item.lg-next-slide, .lg-css3.lg-fade .lg-item.lg-current {
  transition: opacity 0.1s ease 0s;
}

.lg-css3.lg-slide.lg-use-css3 .lg-item {
  opacity: 0;
}

.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-prev-slide {
  transform: translate3d(-100%, 0, 0);
}

.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-next-slide {
  transform: translate3d(100%, 0, 0);
}

.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-current {
  transform: translate3d(0, 0, 0);
  opacity: 1;
}

.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-prev-slide, .lg-css3.lg-slide.lg-use-css3 .lg-item.lg-next-slide, .lg-css3.lg-slide.lg-use-css3 .lg-item.lg-current {
  transition: transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
}

.lg-css3.lg-slide.lg-use-left .lg-item {
  opacity: 0;
  position: absolute;
  left: 0;
}

.lg-css3.lg-slide.lg-use-left .lg-item.lg-prev-slide {
  left: -100%;
}

.lg-css3.lg-slide.lg-use-left .lg-item.lg-next-slide {
  left: 100%;
}

.lg-css3.lg-slide.lg-use-left .lg-item.lg-current {
  left: 0;
  opacity: 1;
}

.lg-css3.lg-slide.lg-use-left .lg-item.lg-prev-slide, .lg-css3.lg-slide.lg-use-left .lg-item.lg-next-slide, .lg-css3.lg-slide.lg-use-left .lg-item.lg-current {
  transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;
}
`, "",{"version":3,"sources":["webpack://./node_modules/lightgallery.js/dist/css/lightgallery.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,8KAAoJ;EACpJ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,aAAa;EACb,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAsCA;EACE;IACE,OAAO;EACT;EACA;IACE,WAAW;EACb;EACA;IACE,OAAO;EACT;AACF;;AAsCA;EACE;IACE,OAAO;EACT;EACA;IACE,UAAU;EACZ;EACA;IACE,OAAO;EACT;AACF;;AAEA;EAGE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EAGE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAGhB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EAIV,2HAA2H;AAC7H;;AAEA;EACE,UAAU;EAEV,mCAAmC;AACrC;;AAEA;EACE,UAAU;EAEV,kCAAkC;AACpC;;AAEA;EACE,UAAU;EAEV,mCAAmC;AACrC;;AAEA;EAEE,iCAAiC;EACjC,UAAU;EAIV,gHAAgH;EAIhH,yBAAyB;AAC3B;;AAEA;EAEE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EAEjB,kCAAkC;EAIlC,0DAA0D;AAC5D;;AAEA;EAGE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EAGZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EAEE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IAGE,mCAAmC;EACrC;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAGE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oFAAyE;AAC3E;;AAEA;EACE,wFAA6E;AAC/E;;AAEA;EACE,oFAAyE;EACzE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oFAA2E;AAC7E;;AAEA;EACE,wFAA+E;AACjF;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,aAAa;EACb,UAAU;EAIV,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EAIE,yDAAyD;AAC3D;;AAEA;EAIE,6FAA6F;AAC/F;;AAEA;EAEE,+BAA+B;EAG/B,2BAA2B;AAC7B;;AAEA;EAEE,2BAA2B;EAI3B,mFAAmF;EAInF,qBAAqB;EAGrB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EAEV,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAIlB,0DAA0D;EAE1D,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,oDAAoD;EACpD,cAAc;EACd,YAAY;EAGZ,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,SAAS;EACT,eAAe;EACf,OAAO;EACP,eAAe;EACf,QAAQ;EACR,MAAM;EACN,aAAa;EACb,UAAU;EACV,kBAAkB;EAGlB,+DAA+D;AACjE;;AAEA;EAEE,oBAAoB;EAKpB,iCAAiC;EACjC,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;EAKlB,iCAAiC;EAIjC,yFAAyF;AAC3F;;AAEA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oEAAoE;EACpE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EAIT,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;GACE,OAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,UAAU;EACV,aAAa;EAGb,iCAAiC;AACnC;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,uCAAuC;EAEvC,8CAA8C;AAChD;;AAEA;EAEE,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EAGE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EAGZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,8FAAgF;EAChF,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EAGV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,UAAU;EAGV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EAIE,sCAAsC;AACxC;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EAIE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,mCAAmC;AACrC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EAEE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EAIE,6EAA6E;AAC/E;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,UAAU;AACZ;;AAEA;EAIE,wEAAwE;AAC1E","sourcesContent":["@font-face {\n  font-family: 'lg';\n  src: url(\"../fonts/lg.ttf?22t19m\") format(\"truetype\"), url(\"../fonts/lg.woff?22t19m\") format(\"woff\"), url(\"../fonts/lg.svg?22t19m#lg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n.lg-icon {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'lg' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.lg-actions .lg-next, .lg-actions .lg-prev {\n  background-color: rgba(0, 0, 0, 0.45);\n  border-radius: 2px;\n  color: #999;\n  cursor: pointer;\n  display: block;\n  font-size: 22px;\n  margin-top: -10px;\n  padding: 8px 10px 9px;\n  position: absolute;\n  top: 50%;\n  z-index: 1080;\n  outline: none;\n  border: none;\n  background-color: transparent;\n}\n\n.lg-actions .lg-next.disabled, .lg-actions .lg-prev.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.lg-actions .lg-next:hover, .lg-actions .lg-prev:hover {\n  color: #FFF;\n}\n\n.lg-actions .lg-next {\n  right: 20px;\n}\n\n.lg-actions .lg-next:before {\n  content: \"\\e095\";\n}\n\n.lg-actions .lg-prev {\n  left: 20px;\n}\n\n.lg-actions .lg-prev:after {\n  content: \"\\e094\";\n}\n\n@-webkit-keyframes lg-right-end {\n  0% {\n    left: 0;\n  }\n  50% {\n    left: -30px;\n  }\n  100% {\n    left: 0;\n  }\n}\n\n@-moz-keyframes lg-right-end {\n  0% {\n    left: 0;\n  }\n  50% {\n    left: -30px;\n  }\n  100% {\n    left: 0;\n  }\n}\n\n@-ms-keyframes lg-right-end {\n  0% {\n    left: 0;\n  }\n  50% {\n    left: -30px;\n  }\n  100% {\n    left: 0;\n  }\n}\n\n@keyframes lg-right-end {\n  0% {\n    left: 0;\n  }\n  50% {\n    left: -30px;\n  }\n  100% {\n    left: 0;\n  }\n}\n\n@-webkit-keyframes lg-left-end {\n  0% {\n    left: 0;\n  }\n  50% {\n    left: 30px;\n  }\n  100% {\n    left: 0;\n  }\n}\n\n@-moz-keyframes lg-left-end {\n  0% {\n    left: 0;\n  }\n  50% {\n    left: 30px;\n  }\n  100% {\n    left: 0;\n  }\n}\n\n@-ms-keyframes lg-left-end {\n  0% {\n    left: 0;\n  }\n  50% {\n    left: 30px;\n  }\n  100% {\n    left: 0;\n  }\n}\n\n@keyframes lg-left-end {\n  0% {\n    left: 0;\n  }\n  50% {\n    left: 30px;\n  }\n  100% {\n    left: 0;\n  }\n}\n\n.lg-outer.lg-right-end .lg-object {\n  -webkit-animation: lg-right-end 0.3s;\n  -o-animation: lg-right-end 0.3s;\n  animation: lg-right-end 0.3s;\n  position: relative;\n}\n\n.lg-outer.lg-left-end .lg-object {\n  -webkit-animation: lg-left-end 0.3s;\n  -o-animation: lg-left-end 0.3s;\n  animation: lg-left-end 0.3s;\n  position: relative;\n}\n\n.lg-toolbar {\n  z-index: 1082;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.45);\n}\n\n.lg-toolbar .lg-icon {\n  color: #999;\n  cursor: pointer;\n  float: right;\n  font-size: 24px;\n  height: 47px;\n  line-height: 27px;\n  padding: 10px 0;\n  text-align: center;\n  width: 50px;\n  text-decoration: none !important;\n  outline: medium none;\n  background: none;\n  border: none;\n  box-shadow: none;\n  -webkit-transition: color 0.2s linear;\n  -o-transition: color 0.2s linear;\n  transition: color 0.2s linear;\n}\n\n.lg-toolbar .lg-icon:hover {\n  color: #FFF;\n}\n\n.lg-toolbar .lg-close:after {\n  content: \"\\e070\";\n}\n\n.lg-toolbar .lg-download:after {\n  content: \"\\e0f2\";\n}\n\n.lg-sub-html {\n  background-color: rgba(0, 0, 0, 0.45);\n  bottom: 0;\n  color: #EEE;\n  font-size: 16px;\n  left: 0;\n  padding: 10px 40px;\n  position: fixed;\n  right: 0;\n  text-align: center;\n  z-index: 1080;\n}\n\n.lg-sub-html h4 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.lg-sub-html p {\n  font-size: 12px;\n  margin: 5px 0 0;\n}\n\n#lg-counter {\n  color: #999;\n  display: inline-block;\n  font-size: 16px;\n  padding-left: 20px;\n  padding-top: 12px;\n  vertical-align: middle;\n}\n\n.lg-toolbar, .lg-prev, .lg-next {\n  opacity: 1;\n  -webkit-transition: -webkit-transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, color 0.2s linear;\n  -moz-transition: -moz-transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, color 0.2s linear;\n  -o-transition: -o-transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, color 0.2s linear;\n  transition: transform 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.35s cubic-bezier(0, 0, 0.25, 1) 0s, color 0.2s linear;\n}\n\n.lg-hide-items .lg-prev {\n  opacity: 0;\n  -webkit-transform: translate3d(-10px, 0, 0);\n  transform: translate3d(-10px, 0, 0);\n}\n\n.lg-hide-items .lg-next {\n  opacity: 0;\n  -webkit-transform: translate3d(10px, 0, 0);\n  transform: translate3d(10px, 0, 0);\n}\n\n.lg-hide-items .lg-toolbar {\n  opacity: 0;\n  -webkit-transform: translate3d(0, -10px, 0);\n  transform: translate3d(0, -10px, 0);\n}\n\nbody:not(.lg-from-hash) .lg-outer.lg-start-zoom .lg-object {\n  -webkit-transform: scale3d(0.5, 0.5, 0.5);\n  transform: scale3d(0.5, 0.5, 0.5);\n  opacity: 0;\n  -webkit-transition: -webkit-transform 250ms cubic-bezier(0, 0, 0.25, 1) 0s, opacity 250ms cubic-bezier(0, 0, 0.25, 1) !important;\n  -moz-transition: -moz-transform 250ms cubic-bezier(0, 0, 0.25, 1) 0s, opacity 250ms cubic-bezier(0, 0, 0.25, 1) !important;\n  -o-transition: -o-transform 250ms cubic-bezier(0, 0, 0.25, 1) 0s, opacity 250ms cubic-bezier(0, 0, 0.25, 1) !important;\n  transition: transform 250ms cubic-bezier(0, 0, 0.25, 1) 0s, opacity 250ms cubic-bezier(0, 0, 0.25, 1) !important;\n  -webkit-transform-origin: 50% 50%;\n  -moz-transform-origin: 50% 50%;\n  -ms-transform-origin: 50% 50%;\n  transform-origin: 50% 50%;\n}\n\nbody:not(.lg-from-hash) .lg-outer.lg-start-zoom .lg-item.lg-complete .lg-object {\n  -webkit-transform: scale3d(1, 1, 1);\n  transform: scale3d(1, 1, 1);\n  opacity: 1;\n}\n\n.lg-outer .lg-thumb-outer {\n  background-color: #0D0A0A;\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n  z-index: 1080;\n  max-height: 350px;\n  -webkit-transform: translate3d(0, 100%, 0);\n  transform: translate3d(0, 100%, 0);\n  -webkit-transition: -webkit-transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;\n  -moz-transition: -moz-transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;\n  -o-transition: -o-transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;\n  transition: transform 0.25s cubic-bezier(0, 0, 0.25, 1) 0s;\n}\n\n.lg-outer .lg-thumb-outer.lg-grab .lg-thumb-item {\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n  cursor: -o-grab;\n  cursor: -ms-grab;\n  cursor: grab;\n}\n\n.lg-outer .lg-thumb-outer.lg-grabbing .lg-thumb-item {\n  cursor: move;\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n  cursor: -o-grabbing;\n  cursor: -ms-grabbing;\n  cursor: grabbing;\n}\n\n.lg-outer .lg-thumb-outer.lg-dragging .lg-thumb {\n  -webkit-transition-duration: 0s !important;\n  transition-duration: 0s !important;\n}\n\n.lg-outer.lg-thumb-open .lg-thumb-outer {\n  -webkit-transform: translate3d(0, 0%, 0);\n  transform: translate3d(0, 0%, 0);\n}\n\n.lg-outer .lg-thumb {\n  padding: 10px 0;\n  height: 100%;\n  margin-bottom: -5px;\n}\n\n.lg-outer .lg-thumb-item {\n  border-radius: 5px;\n  cursor: pointer;\n  float: left;\n  overflow: hidden;\n  height: 100%;\n  border: 2px solid #FFF;\n  border-radius: 4px;\n  margin-bottom: 5px;\n}\n\n@media (min-width: 1025px) {\n  .lg-outer .lg-thumb-item {\n    -webkit-transition: border-color 0.25s ease;\n    -o-transition: border-color 0.25s ease;\n    transition: border-color 0.25s ease;\n  }\n}\n\n.lg-outer .lg-thumb-item.active, .lg-outer .lg-thumb-item:hover {\n  border-color: #a90707;\n}\n\n.lg-outer .lg-thumb-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.lg-outer.lg-has-thumb .lg-item {\n  padding-bottom: 120px;\n}\n\n.lg-outer.lg-can-toggle .lg-item {\n  padding-bottom: 0;\n}\n\n.lg-outer.lg-pull-caption-up .lg-sub-html {\n  -webkit-transition: bottom 0.25s ease;\n  -o-transition: bottom 0.25s ease;\n  transition: bottom 0.25s ease;\n}\n\n.lg-outer.lg-pull-caption-up.lg-thumb-open .lg-sub-html {\n  bottom: 100px;\n}\n\n.lg-outer .lg-toggle-thumb {\n  background-color: #0D0A0A;\n  border-radius: 2px 2px 0 0;\n  color: #999;\n  cursor: pointer;\n  font-size: 24px;\n  height: 39px;\n  line-height: 27px;\n  padding: 5px 0;\n  position: absolute;\n  right: 20px;\n  text-align: center;\n  top: -39px;\n  width: 50px;\n  outline: medium none;\n  border: none;\n}\n\n.lg-outer .lg-toggle-thumb:after {\n  content: \"\\e1ff\";\n}\n\n.lg-outer .lg-toggle-thumb:hover {\n  color: #FFF;\n}\n\n.lg-outer .lg-video-cont {\n  display: inline-block;\n  vertical-align: middle;\n  max-width: 1140px;\n  max-height: 100%;\n  width: 100%;\n  padding: 0 5px;\n}\n\n.lg-outer .lg-video {\n  width: 100%;\n  height: 0;\n  padding-bottom: 56.25%;\n  overflow: hidden;\n  position: relative;\n}\n\n.lg-outer .lg-video .lg-object {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.lg-outer .lg-video .lg-video-play {\n  width: 84px;\n  height: 59px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin-left: -42px;\n  margin-top: -30px;\n  z-index: 1080;\n  cursor: pointer;\n}\n\n.lg-outer .lg-has-vimeo .lg-video-play {\n  background: url(\"../img/vimeo-play.png\") no-repeat scroll 0 0 transparent;\n}\n\n.lg-outer .lg-has-vimeo:hover .lg-video-play {\n  background: url(\"../img/vimeo-play.png\") no-repeat scroll 0 -58px transparent;\n}\n\n.lg-outer .lg-has-html5 .lg-video-play {\n  background: transparent url(\"../img/video-play.png\") no-repeat scroll 0 0;\n  height: 64px;\n  margin-left: -32px;\n  margin-top: -32px;\n  width: 64px;\n  opacity: 0.8;\n}\n\n.lg-outer .lg-has-html5:hover .lg-video-play {\n  opacity: 1;\n}\n\n.lg-outer .lg-has-youtube .lg-video-play {\n  background: url(\"../img/youtube-play.png\") no-repeat scroll 0 0 transparent;\n}\n\n.lg-outer .lg-has-youtube:hover .lg-video-play {\n  background: url(\"../img/youtube-play.png\") no-repeat scroll 0 -60px transparent;\n}\n\n.lg-outer .lg-video-object {\n  width: 100% !important;\n  height: 100% !important;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.lg-outer .lg-has-video .lg-video-object {\n  visibility: hidden;\n}\n\n.lg-outer .lg-has-video.lg-video-playing .lg-object, .lg-outer .lg-has-video.lg-video-playing .lg-video-play {\n  display: none;\n}\n\n.lg-outer .lg-has-video.lg-video-playing .lg-video-object {\n  visibility: visible;\n}\n\n.lg-progress-bar {\n  background-color: #333;\n  height: 5px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 1083;\n  opacity: 0;\n  -webkit-transition: opacity 0.08s ease 0s;\n  -moz-transition: opacity 0.08s ease 0s;\n  -o-transition: opacity 0.08s ease 0s;\n  transition: opacity 0.08s ease 0s;\n}\n\n.lg-progress-bar .lg-progress {\n  background-color: #a90707;\n  height: 5px;\n  width: 0;\n}\n\n.lg-progress-bar.lg-start .lg-progress {\n  width: 100%;\n}\n\n.lg-show-autoplay .lg-progress-bar {\n  opacity: 1;\n}\n\n.lg-autoplay-button:after {\n  content: \"\\e01d\";\n}\n\n.lg-show-autoplay .lg-autoplay-button:after {\n  content: \"\\e01a\";\n}\n\n.lg-outer.lg-css3.lg-zoom-dragging .lg-item.lg-complete.lg-zoomable .lg-img-wrap, .lg-outer.lg-css3.lg-zoom-dragging .lg-item.lg-complete.lg-zoomable .lg-image {\n  -webkit-transition-duration: 0s;\n  transition-duration: 0s;\n}\n\n.lg-outer.lg-use-transition-for-zoom .lg-item.lg-complete.lg-zoomable .lg-img-wrap {\n  -webkit-transition: -webkit-transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;\n  -moz-transition: -moz-transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;\n  -o-transition: -o-transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;\n  transition: transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;\n}\n\n.lg-outer.lg-use-left-for-zoom .lg-item.lg-complete.lg-zoomable .lg-img-wrap {\n  -webkit-transition: left 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, top 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;\n  -moz-transition: left 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, top 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;\n  -o-transition: left 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, top 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;\n  transition: left 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, top 0.3s cubic-bezier(0, 0, 0.25, 1) 0s;\n}\n\n.lg-outer .lg-item.lg-complete.lg-zoomable .lg-img-wrap {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.lg-outer .lg-item.lg-complete.lg-zoomable .lg-image {\n  -webkit-transform: scale3d(1, 1, 1);\n  transform: scale3d(1, 1, 1);\n  -webkit-transition: -webkit-transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.15s !important;\n  -moz-transition: -moz-transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.15s !important;\n  -o-transition: -o-transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.15s !important;\n  transition: transform 0.3s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.15s !important;\n  -webkit-transform-origin: 0 0;\n  -moz-transform-origin: 0 0;\n  -ms-transform-origin: 0 0;\n  transform-origin: 0 0;\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n#lg-zoom-in:after {\n  content: \"\\e311\";\n}\n\n#lg-actual-size {\n  font-size: 20px;\n}\n\n#lg-actual-size:after {\n  content: \"\\e033\";\n}\n\n#lg-zoom-out {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n#lg-zoom-out:after {\n  content: \"\\e312\";\n}\n\n.lg-zoomed #lg-zoom-out {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.lg-outer .lg-pager-outer {\n  bottom: 60px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  z-index: 1080;\n  height: 10px;\n}\n\n.lg-outer .lg-pager-outer.lg-pager-hover .lg-pager-cont {\n  overflow: visible;\n}\n\n.lg-outer .lg-pager-cont {\n  cursor: pointer;\n  display: inline-block;\n  overflow: hidden;\n  position: relative;\n  vertical-align: top;\n  margin: 0 5px;\n}\n\n.lg-outer .lg-pager-cont:hover .lg-pager-thumb-cont {\n  opacity: 1;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.lg-outer .lg-pager-cont.lg-pager-active .lg-pager {\n  box-shadow: 0 0 0 2px white inset;\n}\n\n.lg-outer .lg-pager-thumb-cont {\n  background-color: #fff;\n  color: #FFF;\n  bottom: 100%;\n  height: 83px;\n  left: 0;\n  margin-bottom: 20px;\n  margin-left: -60px;\n  opacity: 0;\n  padding: 5px;\n  position: absolute;\n  width: 120px;\n  border-radius: 3px;\n  -webkit-transition: opacity 0.15s ease 0s, -webkit-transform 0.15s ease 0s;\n  -moz-transition: opacity 0.15s ease 0s, -moz-transform 0.15s ease 0s;\n  -o-transition: opacity 0.15s ease 0s, -o-transform 0.15s ease 0s;\n  transition: opacity 0.15s ease 0s, transform 0.15s ease 0s;\n  -webkit-transform: translate3d(0, 5px, 0);\n  transform: translate3d(0, 5px, 0);\n}\n\n.lg-outer .lg-pager-thumb-cont img {\n  width: 100%;\n  height: 100%;\n}\n\n.lg-outer .lg-pager {\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n  box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.7) inset;\n  display: block;\n  height: 12px;\n  -webkit-transition: box-shadow 0.3s ease 0s;\n  -o-transition: box-shadow 0.3s ease 0s;\n  transition: box-shadow 0.3s ease 0s;\n  width: 12px;\n}\n\n.lg-outer .lg-pager:hover, .lg-outer .lg-pager:focus {\n  box-shadow: 0 0 0 8px white inset;\n}\n\n.lg-outer .lg-caret {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px dashed;\n  bottom: -10px;\n  display: inline-block;\n  height: 0;\n  left: 50%;\n  margin-left: -5px;\n  position: absolute;\n  vertical-align: middle;\n  width: 0;\n}\n\n.lg-fullscreen:after {\n  content: \"\\e20c\";\n}\n\n.lg-fullscreen-on .lg-fullscreen:after {\n  content: \"\\e20d\";\n}\n\n.lg-outer #lg-dropdown-overlay {\n  background-color: rgba(0, 0, 0, 0.25);\n  bottom: 0;\n  cursor: default;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1081;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: visibility 0s linear 0.18s, opacity 0.18s linear 0s;\n  -o-transition: visibility 0s linear 0.18s, opacity 0.18s linear 0s;\n  transition: visibility 0s linear 0.18s, opacity 0.18s linear 0s;\n}\n\n.lg-outer.lg-dropdown-active .lg-dropdown, .lg-outer.lg-dropdown-active #lg-dropdown-overlay {\n  -webkit-transition-delay: 0s;\n  transition-delay: 0s;\n  -moz-transform: translate3d(0, 0px, 0);\n  -o-transform: translate3d(0, 0px, 0);\n  -ms-transform: translate3d(0, 0px, 0);\n  -webkit-transform: translate3d(0, 0px, 0);\n  transform: translate3d(0, 0px, 0);\n  opacity: 1;\n  visibility: visible;\n}\n\n.lg-outer.lg-dropdown-active #lg-share {\n  color: #FFF;\n}\n\n.lg-outer .lg-dropdown {\n  background-color: #fff;\n  border-radius: 2px;\n  font-size: 14px;\n  list-style-type: none;\n  margin: 0;\n  padding: 10px 0;\n  position: absolute;\n  right: 0;\n  text-align: left;\n  top: 50px;\n  opacity: 0;\n  visibility: hidden;\n  -moz-transform: translate3d(0, 5px, 0);\n  -o-transform: translate3d(0, 5px, 0);\n  -ms-transform: translate3d(0, 5px, 0);\n  -webkit-transform: translate3d(0, 5px, 0);\n  transform: translate3d(0, 5px, 0);\n  -webkit-transition: -webkit-transform 0.18s linear 0s, visibility 0s linear 0.5s, opacity 0.18s linear 0s;\n  -moz-transition: -moz-transform 0.18s linear 0s, visibility 0s linear 0.5s, opacity 0.18s linear 0s;\n  -o-transition: -o-transform 0.18s linear 0s, visibility 0s linear 0.5s, opacity 0.18s linear 0s;\n  transition: transform 0.18s linear 0s, visibility 0s linear 0.5s, opacity 0.18s linear 0s;\n}\n\n.lg-outer .lg-dropdown:after {\n  content: \"\";\n  display: block;\n  height: 0;\n  width: 0;\n  position: absolute;\n  border: 8px solid transparent;\n  border-bottom-color: #FFF;\n  right: 16px;\n  top: -16px;\n}\n\n.lg-outer .lg-dropdown > li:last-child {\n  margin-bottom: 0px;\n}\n\n.lg-outer .lg-dropdown > li:hover a, .lg-outer .lg-dropdown > li:hover .lg-icon {\n  color: #333;\n}\n\n.lg-outer .lg-dropdown a {\n  color: #333;\n  display: block;\n  white-space: pre;\n  padding: 4px 12px;\n  font-family: \"Open Sans\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;\n  font-size: 12px;\n}\n\n.lg-outer .lg-dropdown a:hover {\n  background-color: rgba(0, 0, 0, 0.07);\n}\n\n.lg-outer .lg-dropdown .lg-dropdown-text {\n  display: inline-block;\n  line-height: 1;\n  margin-top: -3px;\n  vertical-align: middle;\n}\n\n.lg-outer .lg-dropdown .lg-icon {\n  color: #333;\n  display: inline-block;\n  float: none;\n  font-size: 20px;\n  height: auto;\n  line-height: 1;\n  margin-right: 8px;\n  padding: 0;\n  vertical-align: middle;\n  width: auto;\n}\n\n.lg-outer #lg-share {\n  position: relative;\n}\n\n.lg-outer #lg-share:after {\n  content: \"\\e80d\";\n}\n\n.lg-outer #lg-share-facebook .lg-icon {\n  color: #3b5998;\n}\n\n.lg-outer #lg-share-facebook .lg-icon:after {\n  content: \"\\e904\";\n}\n\n.lg-outer #lg-share-twitter .lg-icon {\n  color: #00aced;\n}\n\n.lg-outer #lg-share-twitter .lg-icon:after {\n  content: \"\\e907\";\n}\n\n.lg-outer #lg-share-googleplus .lg-icon {\n  color: #dd4b39;\n}\n\n.lg-outer #lg-share-googleplus .lg-icon:after {\n  content: \"\\e905\";\n}\n\n.lg-outer #lg-share-pinterest .lg-icon {\n  color: #cb2027;\n}\n\n.lg-outer #lg-share-pinterest .lg-icon:after {\n  content: \"\\e906\";\n}\n\n.lg-outer .lg-img-rotate {\n  position: absolute;\n  padding: 0 5px;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.32, 0, 0.67, 0) 0s;\n  -moz-transition: -moz-transform 0.3s cubic-bezier(0.32, 0, 0.67, 0) 0s;\n  -o-transition: -o-transform 0.3s cubic-bezier(0.32, 0, 0.67, 0) 0s;\n  transition: transform 0.3s cubic-bezier(0.32, 0, 0.67, 0) 0s;\n}\n\n.lg-rotate-left:after {\n  content: \"\\e900\";\n}\n\n.lg-rotate-right:after {\n  content: \"\\e901\";\n}\n\n.lg-icon.lg-flip-hor, .lg-icon.lg-flip-ver {\n  font-size: 26px;\n}\n\n.lg-flip-hor:after {\n  content: \"\\e902\";\n}\n\n.lg-flip-ver:after {\n  content: \"\\e903\";\n}\n\n.lg-group {\n  *zoom: 1;\n}\n\n.lg-group:before, .lg-group:after {\n  display: table;\n  content: \"\";\n  line-height: 0;\n}\n\n.lg-group:after {\n  clear: both;\n}\n\n.lg-outer {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  opacity: 0;\n  outline: none;\n  -webkit-transition: opacity 0.15s ease 0s;\n  -o-transition: opacity 0.15s ease 0s;\n  transition: opacity 0.15s ease 0s;\n}\n\n.lg-outer * {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.lg-outer.lg-visible {\n  opacity: 1;\n}\n\n.lg-outer.lg-css3 .lg-item.lg-prev-slide, .lg-outer.lg-css3 .lg-item.lg-next-slide, .lg-outer.lg-css3 .lg-item.lg-current {\n  -webkit-transition-duration: inherit !important;\n  transition-duration: inherit !important;\n  -webkit-transition-timing-function: inherit !important;\n  transition-timing-function: inherit !important;\n}\n\n.lg-outer.lg-css3.lg-dragging .lg-item.lg-prev-slide, .lg-outer.lg-css3.lg-dragging .lg-item.lg-next-slide, .lg-outer.lg-css3.lg-dragging .lg-item.lg-current {\n  -webkit-transition-duration: 0s !important;\n  transition-duration: 0s !important;\n  opacity: 1;\n}\n\n.lg-outer.lg-grab img.lg-object {\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n  cursor: -o-grab;\n  cursor: -ms-grab;\n  cursor: grab;\n}\n\n.lg-outer.lg-grabbing img.lg-object {\n  cursor: move;\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n  cursor: -o-grabbing;\n  cursor: -ms-grabbing;\n  cursor: grabbing;\n}\n\n.lg-outer .lg {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.lg-outer .lg-inner {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  white-space: nowrap;\n}\n\n.lg-outer .lg-item {\n  background: url(\"../img/loading.gif\") no-repeat scroll center center transparent;\n  display: none !important;\n}\n\n.lg-outer.lg-css3 .lg-prev-slide, .lg-outer.lg-css3 .lg-current, .lg-outer.lg-css3 .lg-next-slide {\n  display: inline-block !important;\n}\n\n.lg-outer.lg-css .lg-current {\n  display: inline-block !important;\n}\n\n.lg-outer .lg-item, .lg-outer .lg-img-wrap {\n  display: inline-block;\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.lg-outer .lg-item:before, .lg-outer .lg-img-wrap:before {\n  content: \"\";\n  display: inline-block;\n  height: 50%;\n  width: 1px;\n  margin-right: -1px;\n}\n\n.lg-outer .lg-img-wrap {\n  position: absolute;\n  padding: 0 5px;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.lg-outer .lg-item.lg-complete {\n  background-image: none;\n}\n\n.lg-outer .lg-item.lg-current {\n  z-index: 1060;\n}\n\n.lg-outer .lg-image {\n  display: inline-block;\n  vertical-align: middle;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto !important;\n  height: auto !important;\n}\n\n.lg-outer.lg-show-after-load .lg-item .lg-object, .lg-outer.lg-show-after-load .lg-item .lg-video-play {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s ease 0s;\n  -o-transition: opacity 0.15s ease 0s;\n  transition: opacity 0.15s ease 0s;\n}\n\n.lg-outer.lg-show-after-load .lg-item.lg-complete .lg-object, .lg-outer.lg-show-after-load .lg-item.lg-complete .lg-video-play {\n  opacity: 1;\n}\n\n.lg-outer .lg-empty-html {\n  display: none;\n}\n\n.lg-outer.lg-hide-download #lg-download {\n  display: none;\n}\n\n.lg-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1040;\n  background-color: #000;\n  opacity: 0;\n  -webkit-transition: opacity 0.15s ease 0s;\n  -o-transition: opacity 0.15s ease 0s;\n  transition: opacity 0.15s ease 0s;\n}\n\n.lg-backdrop.in {\n  opacity: 1;\n}\n\n.lg-css3.lg-no-trans .lg-prev-slide, .lg-css3.lg-no-trans .lg-next-slide, .lg-css3.lg-no-trans .lg-current {\n  -webkit-transition: none 0s ease 0s !important;\n  -moz-transition: none 0s ease 0s !important;\n  -o-transition: none 0s ease 0s !important;\n  transition: none 0s ease 0s !important;\n}\n\n.lg-css3.lg-use-css3 .lg-item {\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.lg-css3.lg-use-left .lg-item {\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.lg-css3.lg-fade .lg-item {\n  opacity: 0;\n}\n\n.lg-css3.lg-fade .lg-item.lg-current {\n  opacity: 1;\n}\n\n.lg-css3.lg-fade .lg-item.lg-prev-slide, .lg-css3.lg-fade .lg-item.lg-next-slide, .lg-css3.lg-fade .lg-item.lg-current {\n  -webkit-transition: opacity 0.1s ease 0s;\n  -moz-transition: opacity 0.1s ease 0s;\n  -o-transition: opacity 0.1s ease 0s;\n  transition: opacity 0.1s ease 0s;\n}\n\n.lg-css3.lg-slide.lg-use-css3 .lg-item {\n  opacity: 0;\n}\n\n.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-prev-slide {\n  -webkit-transform: translate3d(-100%, 0, 0);\n  transform: translate3d(-100%, 0, 0);\n}\n\n.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-next-slide {\n  -webkit-transform: translate3d(100%, 0, 0);\n  transform: translate3d(100%, 0, 0);\n}\n\n.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-current {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n}\n\n.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-prev-slide, .lg-css3.lg-slide.lg-use-css3 .lg-item.lg-next-slide, .lg-css3.lg-slide.lg-use-css3 .lg-item.lg-current {\n  -webkit-transition: -webkit-transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\n  -moz-transition: -moz-transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\n  -o-transition: -o-transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\n  transition: transform 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\n}\n\n.lg-css3.lg-slide.lg-use-left .lg-item {\n  opacity: 0;\n  position: absolute;\n  left: 0;\n}\n\n.lg-css3.lg-slide.lg-use-left .lg-item.lg-prev-slide {\n  left: -100%;\n}\n\n.lg-css3.lg-slide.lg-use-left .lg-item.lg-next-slide {\n  left: 100%;\n}\n\n.lg-css3.lg-slide.lg-use-left .lg-item.lg-current {\n  left: 0;\n  opacity: 1;\n}\n\n.lg-css3.lg-slide.lg-use-left .lg-item.lg-prev-slide, .lg-css3.lg-slide.lg-use-left .lg-item.lg-next-slide, .lg-css3.lg-slide.lg-use-left .lg-item.lg-current {\n  -webkit-transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\n  -moz-transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\n  -o-transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\n  transition: left 1s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0.1s ease 0s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
